// src/models/landing-page.js
import participantservice from '@/services/participants/participantservice';

// The LandingPage class returns a clean
// LandingPage object with only the data we need.
/*export class Event {
  constructor({
    id = null,
    amount = 0,
    firstname = '',
    lastname = '',
    member = '',
    singleRoom = '',
    sport = '',
    status = null,
    actions = {},
    comment = '',
  } = {}) {
    this.id = id
    this.name = name
    this.amount = amount
    this.firstname = firstname
    this.lastname = lastname
    this.member =member
    this.singleRoom = singleRoom
    this.sport = sport
    this.status = status
    this.actions = actions
    this.comment = comment
  }
}*/

// We use an adapter to bring the API response
// from the Contentful API into the correct format
// for our LandingPage class.
//export function responseAdapter({ fields, sys }) {
//  return new Event({ ...fields, ...sys });
//}

export function responseAdapter(response) {
  return response.data.content;
}

export function responseSingleAdapter(response) {
  return response.data;
}

//function mapAndAdd(out, element){
//  out.push(new Event({ ...element }));
//}

// We wrap the Contentful API client to format
// the response exactly the way we like it.
export default {
  async getAll(eventId) {
    return responseAdapter(await participantservice.getAll(eventId));
  },
  async get(participantId) {
    let out = await participantservice.get(participantId)
    return responseSingleAdapter(out);
  },
  async update(participantId, participant) {
    let out = await participantservice.update(participantId, participant)
    return responseSingleAdapter(out);
  },
  async updateStatus(url) {
    let out = await participantservice.updateStatus(url)
    return responseSingleAdapter(out);
  },
  
};
